import { useTranslation } from 'react-i18next';
import { Icon, GoogleIcon, CloseIcon } from '../components/core';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { signIn, isLoading, error, clearError } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-green-900 to-green-700 px-6 py-10">
      {/* Radial overlays for depth */}
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden="true"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 80%, rgba(255,255,255,.04) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,.06) 0%, transparent 40%)',
        }}
      />

      {/* Card */}
      <div className="relative z-10 w-full max-w-[400px] animate-fade-up rounded-lg bg-white px-10 py-12 text-center shadow-lg">
        {/* Logo */}
        <div className="mb-2 text-5xl opacity-0 animate-fade-up-delay-1">🌱</div>

        {/* Title */}
        <h1 className="mb-1 font-display text-[2rem] font-semibold leading-tight tracking-tight text-green-900 opacity-0 animate-fade-up-delay-1">
          {t('app.name')}
        </h1>

        {/* Tagline */}
        <p className="mb-8 font-body text-sm text-gray-500 opacity-0 animate-fade-up-delay-2">
          {t('app.tagline')}
        </p>

        {/* Error message */}
        {error && (
          <div className="mb-4 flex items-start justify-between gap-3 rounded-sm border border-red-200 bg-red-50 px-4 py-3 text-left">
            <p className="font-body text-sm text-red-600">{error}</p>
            <button
              onClick={clearError}
              aria-label={t('auth.dismissError')}
              className="shrink-0 text-red-400 transition-colors hover:text-red-600"
            >
              <Icon size="sm"><CloseIcon /></Icon>
            </button>
          </div>
        )}

        {/* Google sign-in button */}
        <button
          onClick={() => void signIn()}
          disabled={isLoading}
          className="flex w-full cursor-pointer items-center justify-center gap-3 rounded-sm border-2 border-gray-300 bg-white px-5 py-3.5 font-body text-button font-semibold text-gray-700 transition-agrobook duration-agrobook hover:border-gray-400 hover:bg-gray-50 hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-50 opacity-0 animate-fade-up-delay-2"
        >
          {isLoading ? (
            <>
              <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-green-700" />
              {t('auth.signingIn')}
            </>
          ) : (
            <>
              <Icon size="md" className="shrink-0"><GoogleIcon /></Icon>
              {t('auth.signIn')}
            </>
          )}
        </button>

        {/* Footer note */}
        <p className="mt-6 font-body text-xs text-gray-400 opacity-0 animate-fade-up-delay-3">
          {t('app.secureLogin')}
        </p>
      </div>
    </div>
  );
}
